module.exports = __webpack_public_path__ + "img/daren_6.0f4fd24a.png";